import logo from './logo.svg';
import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import LandingPage from "./components/LandingPage";
import {useEffect, useState} from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ChooseSolderingDevice from "./components/guides/ChooseSolderingDevice";
import Products from "./components/Products";
const ytLink = "https://www.youtube.com/@0x_hash?sub_confirmation=1"
const hashLogo = "/media/img/0xhash.png"
const sectionWidth = "38rem"
const loaderSegments = 50;
const TempSite = () => {
    useEffect(() => {
        document.getElementById("loader-div").style.width = sectionWidth
        document.getElementById("load-txt").style.width =sectionWidth
    }, []);
    const [loading, setLoading] = useState("");
    useEffect(() => {
        if (loading.toString().length < loaderSegments) {
            setTimeout(() => {
                setLoading(loading + "=");

            }, 50)
        }
    }, [loading]);
    return (
        <>
            <div className={"temp-main"}>
                <img src={hashLogo}/>


                        <div className={"loader-div"} id={"loader-div"}>
                            <p>[</p>
                            <p id={"load-txt"}>{loading}{loading.toString().length < loaderSegments ? ">" : ""}</p>
                            <p>]</p>
                        </div>
                        <p className={"loader-percentage"}>Decrypting Message: {100 / loaderSegments * loading.toString().length === 100 ? "Done!" : 100 / loaderSegments * loading.toString().length + "%"}</p>
                <p className={"message"}>Message:</p>
                <p className={"temp-site-text"}>{decryptFeature(dictionary, tempMsg, 100 / loaderSegments * loading.toString().length)}</p>
                {100 / loaderSegments * loading.toString().length === 100 ? <a href={ytLink} target={"_self"} className={"go-to-yt"}>Go To YouTube</a> : <></>}
            </div>
        </>
    )
}

const tempMsg = "This is my current site, but it is in progress. Stay updated for blogs, projects and more!"
const dictionary = "0123456789qwertyuiopasdfghjklzxcvbnm!?></\`~+*=@#$%"

function random_str(dict, length) {
    let result = '';

    for (let i = 0; i < length; i++) {
        const randomInd = Math.floor(Math.random() * dict.length);
        result += dict.charAt(randomInd);
    }
    return result;
}
const decryptFeature = (dict, msg, percentage) => {
    let newMessage = msg;
    if (percentage < 100){
       newMessage = random_str(dict, msg.length);
    }
    console.log(newMessage);
    return newMessage;
}
function App() {

    return (

        <BrowserRouter>
            <header>
                {/*<Header/>*/}
            </header>
            <div className={"spacer"}></div>
            <main>
                <Routes>
                    <Route path="/" element={<TempSite/>}/>
                    {/*<Route path="/" element={<LandingPage/>}/>*/}
                    {/*<Route path="/products" element={<Products/>}/>*/}
                    {/*<Route path="/guides/choosing-soldering-device" element={<ChooseSolderingDevice/>}/>*/}
                </Routes>
            </main>
            <footer>
                {/*<Footer/>*/}
            </footer>
        </BrowserRouter>

    );
}

export default App;
